export default (response, additionalName) => {
  // Convert response to a Blob object
  const blob = new Blob([response.data], { type: 'application/pdf' })

  // Create a URL for the Blob object
  const url = window.URL.createObjectURL(blob)

  // Create a link element to trigger the download
  const link = document.createElement('a')
  link.href = url
  link.download = additionalName ? `${additionalName}.pdf` : 'download.pdf'

  // Append the link to the document body
  document.body.appendChild(link)

  // Click the link to trigger the download
  link.click()

  // Clean up the URL and link elements
  window.URL.revokeObjectURL(url)
  document.body.removeChild(link)
}
